export default {
  name: 'Offer Title',
  edit: {
    form: 'name-input',
    label: 'Change the title',
    handler: value => value,
  },
};
